import { siteName } from '@/mocks/home';

const footerLinks = [
  { label: '剧情梗概', href: '#intro' },
  { label: '全部剧集', href: '#episodes' },
  { label: '核心看点', href: '#themes' },
  { label: '人物关系', href: '#characters' },
  { label: '名场面', href: '#scenes' },
  { label: '追剧指南', href: '#guide' },
  { label: '短剧大合集', href: '#collections' },
  { label: '常见问题', href: '#faq' },
];

export default function Footer() {
  return (
    <footer className="w-full bg-secondary-900 text-secondary-50">
      <div className="px-4 md:px-6 max-w-6xl mx-auto py-12 md:py-16 grid grid-cols-1 md:grid-cols-[1.4fr,1fr,1fr] gap-8 md:gap-12">
        <div>
          <div className="flex items-center gap-2">
            <span className="w-9 h-9 flex items-center justify-center rounded-lg bg-primary-600 text-primary-50 font-heading font-bold text-lg">
              欲
            </span>
            <span className="font-heading text-xl font-bold text-background-50">{siteName}</span>
          </div>
          <p className="mt-4 max-w-md text-sm text-secondary-200/80 leading-relaxed">
            汇总《欲望的诱惑》相关短剧全集资源线索，以短剧、短剧全集、全集免费看与短剧大合集为重点，另有全部剧集与完整短剧等浏览线索，可按需继续查阅。
          </p>
        </div>

        <nav aria-label="页脚导航">
          <h2 className="font-heading text-sm font-bold text-background-50 uppercase tracking-wider">页面分区</h2>
          <ul className="mt-4 grid grid-cols-2 gap-x-6 gap-y-2.5">
            {footerLinks.map((l) => (
              <li key={l.href}>
                <a href={l.href} className="text-sm text-secondary-200/80 hover:text-accent-300 transition-colors">
                  {l.label}
                </a>
              </li>
            ))}
          </ul>
        </nav>

        <div>
          <h2 className="font-heading text-sm font-bold text-background-50 uppercase tracking-wider">内容说明</h2>
          <ul className="mt-4 space-y-2.5 text-sm text-secondary-200/80 leading-relaxed">
            <li className="flex items-start gap-2">
              <i className="ri-book-open-line mt-0.5 text-accent-400 shrink-0" aria-hidden="true" />
              本站为短剧信息与浏览索引页，不提供在线播放与下载。
            </li>
            <li className="flex items-start gap-2">
              <i className="ri-shield-check-line mt-0.5 text-accent-400 shrink-0" aria-hidden="true" />
              剧情、人物与集数为题材向整理，具体内容以实际发布版本为准。
            </li>
          </ul>
        </div>
      </div>

      <div className="border-t border-secondary-700">
        <div className="px-4 md:px-6 max-w-6xl mx-auto py-5 flex flex-col sm:flex-row items-center justify-between gap-2">
          <p className="text-xs md:text-sm text-secondary-300/70">
            © {new Date().getFullYear()} {siteName} · 短剧全集浏览索引
          </p>
          <p className="text-xs md:text-sm text-secondary-300/70">短剧 · 短剧全集 · 全集免费看 · 短剧大合集</p>
        </div>
      </div>
    </footer>
  );
}